var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.genres.length)?_c('div',{staticClass:"genres"},[_c('Select2',{attrs:{"options":_vm.genresOption,"settings":{}},on:{"select":function($event){return _vm.selectGenre($event)}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }